
import $ from 'jquery';


let map = {


    /**initMap
     */
    initMap( $el ) {
      // Find marker elements within map.
      var $markers = $el.find('.marker');

      // Create gerenic map.
      var mapArgs = {
          zoom: 12,
          // disableDefaultUI: true,
          // styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"lightness":"-8"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"weight":"0.01"},{"lightness":"3"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"},{"weight":"0.01"}]},{"featureType":"administrative.province","elementType":"labels.text.stroke","stylers":[{"weight":"0.01"}]},{"featureType":"administrative.locality","elementType":"labels","stylers":[{"lightness":"0"}]},{"featureType":"administrative.locality","elementType":"labels.text.stroke","stylers":[{"weight":"0.01"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.stroke","stylers":[{"weight":"0.01"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.fill","stylers":[{"lightness":"0"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.stroke","stylers":[{"weight":"0.01"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"},{"weight":"0.01"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"lightness":"-13"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"lightness":"0"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"lightness":"-52"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.fill","stylers":[{"lightness":"-42"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"on"},{"weight":"0.01"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"lightness":"-17"},{"weight":"0.01"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"weight":"0.01"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"on"},{"lightness":"-8"}]},{"featureType":"poi.government","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"},{"visibility":"on"},{"weight":"1"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"},{"weight":"2"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":"-15"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"off"},{"weight":"1"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"lightness":"0"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}],
        };
      var map = new google.maps.Map( $el[0], mapArgs );

      // Add markers.
      map.markers = [];
      $markers.each((index, el) => {
        this.initMarker( $(el), map );
      });

      // Center map based on markers.
      this.centerMap( map );

      // Return map instance.
      return map;
    },

    /**initMarker
    */
    initMarker( $marker, map ) {

      // Get position from marker.
      var image = $marker.data('image');
      var icon = $marker.data('icon');
      var title = $marker.data('title');
      var lat = $marker.data('lat');
      var lng = $marker.data('lng');
      var latLng = {
          lat: parseFloat( lat ),
          lng: parseFloat( lng )
      };
      if (this.isJson(window.report_icon)) { 
        const r_icon = JSON.parse(window.report_icon);
        var icon = {
          url: r_icon.encoded,
          size: new google.maps.Size(r_icon.width ? r_icon.width : 22, r_icon.height ? r_icon.height : 22),
          origin: new google.maps.Point(0, 0),
          scaledSize: new google.maps.Size(22, r_icon.count ? r_icon.count * 22 : 22), // scaled size
          anchor: new google.maps.Point(11, 11) // anchor
        }
      } else {
        var icon = {
          url: window.report_icon,
          size: new google.maps.Size(40,40),
          scaledSize: new google.maps.Size(30, 30), // scaled size
          origin: new google.maps.Point(-5, 0),
          anchor: new google.maps.Point(15, 15) // anchor
        };
      }


      var contentString = 
      '<a href="#" class="section__grid__item">'+
        '<div class="section__grid__item__image"> <img src="'+image+'" alt=""> </div>'+
        '<div class="section__grid__item__main">'+
          '<h4 class="section__grid__item__title">'+title+'</h4>'+
          '<div class="section__grid__item__icons">'+
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.85 23"><defs><style>.cls-1{fill:#fdcf30;}.cls-2{fill:#fff;}</style></defs><title>Asset 3</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M422.56,370.8a11.51,11.51,0,1,0-11.43-11.5,11.47,11.47,0,0,0,11.43,11.5" transform="translate(-411.13 -347.79)"/><path class="cls-2" d="M425.73,356.37a3.93,3.93,0,0,0-5.69,0,4.24,4.24,0,0,0,0,5.85,3.95,3.95,0,0,0,5.69,0,4.22,4.22,0,0,0,0-5.85m.32,6.17a4.37,4.37,0,0,1-6.32,0,4.69,4.69,0,0,1,0-6.5,4.37,4.37,0,0,1,6.32,0,4.71,4.71,0,0,1,0,6.5m-10-9.71v2.89h-.46v-2.89h-.49v2.89h-.45v-2.89a7.93,7.93,0,0,0-.76,3.37,1.32,1.32,0,0,0,.52,1.06c.35.27.52.51.52.72v7.78h.84V358c0-.21.18-.45.52-.72a1.32,1.32,0,0,0,.52-1.06,7.79,7.79,0,0,0-.76-3.37m11.16,2a6,6,0,0,0-8.67,0,6.43,6.43,0,0,0,0,8.92,6,6,0,0,0,8.67,0,6.43,6.43,0,0,0,0-8.92m3.25-1.6a1.24,1.24,0,0,0-.73-.4v6.7h.14v6.23h.84v-6.23H431q.25-3,.24-3.6a3.91,3.91,0,0,0-.74-2.7" transform="translate(-411.13 -347.79)"/></g></g></svg>'+
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.26 33.48"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M16.63,33.48A16.74,16.74,0,1,1,33.26,16.74,16.7,16.7,0,0,1,16.63,33.48ZM16.63,2A14.74,14.74,0,1,0,31.26,16.74,14.7,14.7,0,0,0,16.63,2Z"/><polygon points="15.33 25.17 13.94 23.73 20.81 17.07 14.17 10.65 15.56 9.21 23.69 17.07 15.33 25.17"/><rect x="2.04" y="16.19" width="18.98" height="2"/></g></g></svg>'+
          '</div>'+
        '</div>'+
      '</a>';

      // var infowindow = new google.maps.InfoWindow({
      //   content: contentString,
      // });

      // Create marker instance.
      var marker = new google.maps.Marker({
          position : latLng,
          icon: icon,
          map: map
      });

      // Append to reference for later use.
      map.markers.push( marker );

      //click on marker
        // marker.addListener("click", () => {
        //   //let map_url = $('.contact__map__link').attr('href');
        //   //window.open(map_url);
        //   infowindow.open(map, marker);
        // });
    },

    /**centerMap
    */
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },

    centerMap( map ) {

      // Create map boundaries from all map markers.
      var bounds = new google.maps.LatLngBounds();
      map.markers.forEach(function( marker ){
          bounds.extend({
              lat: marker.position.lat(),
              lng: marker.position.lng()
          });
      });

      // Case: Single marker.
      if( map.markers.length == 1 ){
          map.setCenter( bounds.getCenter() );

      // Case: Multiple markers.
      } else{
          map.fitBounds( bounds );
      }
    }



}
export default map;
